import { createRouter, Route } from 'router5';
import { Router } from 'router5/types/types/router';
import browserPlugin from 'router5-plugin-browser';
import listenersPlugin from 'router5-plugin-listeners';

import { RouterConfig } from './types';

export function getMemoizedRouter(routes: Route[], config: RouterConfig): Router {
  // note: lodash memoization is not used here because we need two-level cache per each argument
  const cachedRouter = extractRouterFromCache(routes, config);

  if (cachedRouter) {
    return cachedRouter;
  }

  const { useHash, middlewares, ...createRouterParams } = config;

  const router = createRouter(routes, createRouterParams);

  router.usePlugin(
    browserPlugin({
      useHash,
    }),
  );

  router.usePlugin(listenersPlugin());
  middlewares?.forEach((middleware) => router.useMiddleware(middleware));
  router.setDependency('routes', routes);
  insertRouterIntoCache(routes, config, router);

  return router;
}

const cache = new Map<Route[], Map<RouterConfig, Router>>();

function extractRouterFromCache(routes: Route[], config: RouterConfig): Router | undefined {
  return cache.get(routes)?.get(config);
}

function insertRouterIntoCache(routes: Route[], config: RouterConfig, router: Router): void {
  if (!cache.has(routes)) {
    cache.set(routes, new Map());
  }

  cache.get(routes)?.set(config, router);
}
